
import { Drawer, Box, IconButton, MenuItem, Select } from "@mui/material";
import StyledLink from "../../../../components/basic-styled-components/StyledLink/StyledLink";
import { useConfigurations } from "../../../../context/ConfigurationsContext/ConfigurationsContext";
import { usePrincipalPage } from "../../../../context/PrincipalPageContext/PrincipalPageContext";
import { useAuth } from "../../../../context/AuthContext/AuthContext";
import { useState } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import LogoutModal from "../../../../components/composed-styled-components/LogoutModal/LogoutModal";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import visitaxlogo from "../../../../assets/images/HomePage/VisitiaxColor.png";
import { useLocation } from "react-router-dom";

const PrincipalPageDrawer = () => {
  const configurations = useConfigurations();
  const auth = useAuth();
  const principalpageconfigs = usePrincipalPage();
  const location = useLocation();
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const txt = configurations.txt[configurations.currentlenguage];
  const selectedFlag = configurations.flags[configurations.currentlenguage].toLowerCase();
  const isFaq = location.pathname.startsWith("/FAQS");
  const isBlog = location.pathname.startsWith("/Blog");
  const isHome = !isFaq && !isBlog;

  const getMobileNavStyle = (isActive: boolean) => ({
    color: isActive ? "#952f57" : "#2b2b2b",
    textTransform: "none" as const,
    fontSize: "20px",
    lineHeight: "40px",
    backgroundColor: isActive ? "#e5e4e6" : "transparent",
    borderRadius: isActive ? "7px" : 0,
    width: isActive ? "215px" : "auto",
    minHeight: isActive ? "32px" : "auto",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    paddingInline: isActive ? "10px" : 0,
  });

  return (
    <>
    <Drawer
      anchor="right"
      open={principalpageconfigs.isMenuOpen}
      onClose={principalpageconfigs.toggleMenu}
      ModalProps={{ disableScrollLock: true }}
      sx={{
        display: { xs: "block", lg: "none" },
        "& .MuiDrawer-paper": {
          width: "100vw",
          maxWidth: "100vw",
          height: "100dvh",
          maxHeight: "100dvh",
          margin: 0,
          borderRadius: 0,
          overflow: "visible",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100dvh",
          boxSizing: "border-box",
          overflowY: "auto",
          overflowX: "visible",
          backgroundColor: "#efefef",
          color: "#2b2b2b",
          display: "flex",
          flexDirection: "column",
          px: 2,
          pt: 2,
          pb: 2.5,
        }}
      >
        <Box sx={{ alignItems: "center", display: "flex", justifyContent: "space-between", mb: 5 }}>
          <StyledLink to="/" onClick={principalpageconfigs.toggleMenu} style={{ display: "inline-flex" }}>
            <Box
              component="img"
              src={visitaxlogo}
              alt="VISITAX Logo"
              sx={{ display: "block", width: "80px", height: "41px" }}
            />
          </StyledLink>
          <IconButton
            onClick={principalpageconfigs.toggleMenu}
            aria-label="Cerrar menú"
            sx={{ color: "#9a2f5f", p: 0.5 }}
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>

        <nav style={{ flex: 1 }}>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              alignItems: "center",
            }}
          >
            <li>
              <StyledLink
                variant="navLinksMobile"
                to="/"
                onClick={principalpageconfigs.toggleMenu}
                style={getMobileNavStyle(isHome)}
              >
                Visitax Quintana Roo
              </StyledLink>
            </li>
            {/* <li>
              <StyledLink
                variant="navLinksMobile"
                to="/"
                onClick={handleDestinationsClick}
                style={{ color: "#2b2b2b", textTransform: "none", fontSize: "16px", lineHeight: "35px" }}
              >
                {configurations.txt[configurations.currentlenguage][122]}
              </StyledLink>
            </li> */}
            <li>
              <StyledLink
                variant="navLinksMobile"
                to="/FAQS"
                onClick={principalpageconfigs.toggleMenu}
                style={getMobileNavStyle(isFaq)}
              >
                {txt[194]}
              </StyledLink>
            </li>
            <li>
              <StyledLink
                variant="navLinksMobile"
                to="/Blog"
                onClick={principalpageconfigs.toggleMenu}
                style={getMobileNavStyle(isBlog)}
              >
                {txt[195]}
              </StyledLink>
            </li>
            <li>
              <Box sx={{ width: "78px", height: "1px", bgcolor: "#6f6f6f", mt: 0.5 }} />
            </li>
          </ul>
        </nav>

        <Box sx={{ alignItems: "center", display: "flex", justifyContent: "space-between", mt: "auto", gap: 1.25 }}>
          <Box sx={{ alignItems: "center", display: "flex", gap: 0.5 }}>
            <Box
              component="img"
              srcSet={`https://flagcdn.com/w80/${selectedFlag}.png 2x`}
              src={`https://flagcdn.com/w40/${selectedFlag}.png`}
              alt="Selected Language"
              sx={{ borderRadius: "24px", display: "block", height: "28px", width: "44px" }}
            />
            <Select
              aria-label="Seleccionar idioma"
              variant="standard"
              value={String(configurations.currentlenguage)}
              onChange={(event) => configurations.setLenguage(Number(event.target.value))}
              disableUnderline
              MenuProps={{
                disablePortal: true,
                anchorOrigin: { vertical: "top", horizontal: "left" },
                transformOrigin: { vertical: "bottom", horizontal: "left" },
              }}
              sx={{
                background: "transparent",
                border: "none",
                color: "#1f1f1f",
                cursor: "pointer",
                fontFamily: "Candara",
                fontSize: "15px",
                fontWeight: 600,
                minWidth: "66px",
                outline: "none",
                "& .MuiSelect-select": { py: 0, pr: "0 !important" },
                "& .MuiSelect-icon": { display: "none" },
                "&:before, &:after": { display: "none" },
              }}
            >
              {configurations.lenguageList.map((value, id) => (
                <MenuItem key={id} value={String(id)} sx={{ color: "#1F1F1F" }}>
                  {value}
                </MenuItem>
              ))}
            </Select>
            <KeyboardArrowDownRoundedIcon sx={{ color: "#9a2f5f", fontSize: 19 }} />
          </Box>

          {!auth.validLoggin() ? (
            <StyledLink
              className="loginbtnMobile"
              to="/Login"
              onClick={principalpageconfigs.toggleMenu}
              style={{
                backgroundColor: "#9a2f5f",
                border: "none",
                borderRadius: "22px",
                color: "#fff",
                fontSize: "16px",
                fontWeight: 700,
                marginLeft: 0,
                minWidth: "96px",
                padding: "10px 18px",
                textAlign: "center",
                textTransform: "none",
              }}
            >
              {configurations.txt[configurations.currentlenguage][60]}
            </StyledLink>
          ) : (
            <IconButton onClick={() => setOpenLogoutModal(true)} sx={{ color: "#9a2f5f", p: 0.5 }}>
              <LogoutIcon sx={{ color: "#9a2f5f" }} />
            </IconButton>
          )}
        </Box>
      </Box>
    </Drawer>
    <LogoutModal open={openLogoutModal} onClose={() => setOpenLogoutModal(false)} />

  </>
  );
};
export default PrincipalPageDrawer;
